{
  "pt": {
    "ticket_category": {
      "Decisions": "Decisões",
      "Issue": "Pós-Venda",
      "Other": "Outros",
      "actions": {
        "delete": "Remover tipo de conversação"
      },
      "inputs": {
        "empty": "Nenhum tipo"
      },
      "labels": {
        "delete": "Remover {category}",
        "delete_description": "Tem a certeza de que pretende remover {category} dos seus tipos de conversação?",
        "ticket_categories": "Tipos",
        "ticket_category": "Tipo"
      }
    }
  }
}